import React, { useState, useCallback } from 'react';
import { FaSearch, FaTimes } from 'react-icons/fa';
import '../assets/css/SearchBar.css';
import { useTranslate } from '../services/translation';

interface SearchBarProps {
  onSearch: (query: string) => void;
  placeholder?: string;
  debounceMs?: number;
}

const SearchBar: React.FC<SearchBarProps> = ({
  onSearch,
  placeholder = 'Rechercher...',
  debounceMs = 300,
}) => {
  const [query, setQuery] = useState('');
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);
  const { translate } = useTranslate();
  

  const handleChange = useCallback(
    (value: string) => {
      setQuery(value);

      // Clear existing timeout
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      // Set new timeout for debounced search
      const newTimeoutId = setTimeout(() => {
        onSearch(value);
      }, debounceMs);

      setTimeoutId(newTimeoutId);
    },
    [onSearch, debounceMs, timeoutId]
  );

  const handleClear = useCallback(() => {
    setQuery('');
    onSearch('');
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }, [onSearch, timeoutId]);

  return (
    <div className="search-bar-container">
      <div className="search-bar-wrapper">
        <FaSearch className="search-icon" />
        <input
          type="text"
          value={query}
          onChange={(e) => handleChange(e.target.value)}
          placeholder={placeholder}
          className="search-input"
        />
        {query && (
          <button
            type="button"
            className="search-clear-btn"
            onClick={handleClear}
            aria-label={translate("common.clear_search")}
          >
            <FaTimes />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
